<template>
    <div class="left-container">
        <div class="top-tool">
            <el-button type="primary" plain size="small" @click="addBtnClick">{{ $tt("新增") }}</el-button>
            <el-button type="primary" plain size="small" :disabled="childPageAddDis" @click="addChildPage">{{ $tt("新增子页面") }}</el-button>
            <el-button type="primary" plain size="small" @click="sortBtnClick">{{ $tt("排序") }}</el-button>
        </div>
        <div class="page-tree">
            <el-tree
                ref="pageTreeRef"
                :data="pageOptions"
                :props="defaultProps"
                :expand-on-click-node="false"
                :default-expanded-keys="expandedKeys"
                :highlight-current="true"
                node-key="value"
                @node-click="handlePageClick"
                @node-expand="handeleNodeExpand"
                @node-collapse="handeleNodeCollapse"
                :render-content="renderContent"
            ></el-tree>
        </div>
        <div class="page-components-container">
            <el-collapse v-model="activeNames" @change="handleCollapseChange">
                <el-collapse-item :title="$tt('元素')" name="pageComponents">
                    <CurrentPageComponents :maxH="maxComponentsH" />
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import CurrentPageComponents from "@/components/CurrentPageComponents"; //选择页所使用的组件
import { mapState } from 'vuex';
import eventBus from '@/utils/eventBus';
import { coalescedSetProjectCache } from '@/utils/canvasDraftWriter';

export default {
    props: ['currentPage', 'pageOptions'],
    data() {
        return {
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            activeNames: ['pageComponents'],
            maxComponentsH: null,
            childPageAddDis: true,
            expandedKeys: []
        };
    },
    computed: {
        ...mapState(["componentData", "canvasAllData", "canvasLazyLoad", "cacheCanvasDataKey", "curComponent"])
    },
    components: {
        CurrentPageComponents
    },
    watch: {
        pageOptions: {
            handler: function(value) {
                // 避免出现名字更改，然后选中值丢失
                this.setTreeSelect()
            },
            deep: true,
            immediate: true
        },
        currentPage: {
            handler: function(value) {
                if (value) {
                    this.$nextTick(() => {
                        this.$refs.pageTreeRef.setCurrentKey(value + '');
                        this.setPageMaxH();
                        // 根据选中的值，判断是否可以添加子页面
                        if (this.$refs.pageTreeRef) {
                            var currentNode = this.$refs.pageTreeRef.getCurrentNode();
                            var node = this.$refs.pageTreeRef.getNode(currentNode);
                            this.childPageAddDis = node.level !== 1;
                        }
                    });
                }
            },
            immediate: true
        },
        componentData: function() {
            this.$nextTick(() => {
                this.setPageMaxH();
            });
        },
        curComponent() {
            if (this.activeNames.indexOf("pageComponents") === -1) {
                this.activeNames = ["pageComponents"];
            }
        }
    },
    mounted() {
        this.setCompMaxH();
    },
    methods: {
        addChildPage() {
            this.$emit('addChildPage');
            this.$nextTick(() => {
                const tree = this.$refs.pageTreeRef;
                if (!tree || !tree.store) {
                    return;
                }
                const node = tree.store.getNode(this.currentPage);
                if (node) {
                    node.expand();
                }
                // 选中项由父级 pageSelect(新子页) 更新，勿强制回到父节点 key
            });
        },
        setPageMaxH() {
            var compElement = document.getElementsByClassName('page-components-container')[0];
            var pageElement = document.getElementsByClassName('page-tree')[0];
            var maxH = pageElement.parentElement.clientHeight - 42 - compElement.clientHeight;
            pageElement.style.maxHeight = maxH + 'px';
        },
        addBtnClick() {
            this.$emit('addPage');
            this.$nextTick(() => {
                var treeElement = document.getElementsByClassName('page-tree')[0];
                let endT = treeElement.scrollHeight - treeElement.clientHeight;
                document.getElementsByClassName('page-tree')[0].scrollTop = endT;
            })
        },
        sortBtnClick() {
            this.$emit('sortPage');
        },
        setCompMaxH() {
            this.$nextTick(() => {
                var height = document.getElementsByClassName('page-components-container')[0].parentElement.clientHeight;
                this.maxComponentsH = height / 2 - 42;
            })
        },
        handleCollapseChange(val) {
            this.activeNames = val;
            if (val.length === 0) {
                var pageElement = document.getElementsByClassName('page-tree')[0];
                pageElement.style.maxHeight = 'inherit';
            }
            setTimeout(() => {
                this.$nextTick(() => {
                    this.setPageMaxH();
                });
            }, 300)
        },
        handlePageClick(data, node) {
            if (data.value !== this.currentPage) {
                var parentVal = node.level !== 1 ? node.parent.data.value : null;
                // this.$refs.pageTreeRef.setCurrentKey(null);
                this.$emit('pageSelect', data.value, parentVal)
            }
        },
        handeleNodeExpand(data) {
            this.expandedKeys.push(data.value);
        },
        handeleNodeCollapse(data) {
            if (this.expandedKeys.includes(data.value)) {
                this.expandedKeys.splice(this.expandedKeys.indexOf(data.value), 1)
            }
        },
        /** 复制子页面等场景会整表替换 tree data，需保证父节点在 defaultExpandedKeys 中，否则重建后折叠 */
        addExpandedKey(key) {
            if (key === null || key === undefined || key === '') {
                return;
            }
            const has = this.expandedKeys.some((k) => String(k) === String(key));
            if (!has) {
                this.expandedKeys.push(key);
            }
        },
        /** 树数据更新后强制展开某节点（兼容 key 类型不一致） */
        expandTreeNodeByKey(key) {
            if (key === null || key === undefined || key === '') {
                return;
            }
            this.$nextTick(() => {
                const tree = this.$refs.pageTreeRef;
                if (!tree || !tree.store) {
                    return;
                }
                let node = tree.store.getNode(key);
                if (!node) {
                    node = tree.store.getNode(String(key));
                }
                if (!node && !Number.isNaN(Number(key))) {
                    node = tree.store.getNode(Number(key));
                }
                if (node) {
                    node.expand(null, true);
                }
            });
        },
        setTreeSelect() {
            if (!this.$refs.pageTreeRef) {
                return;
            }
            this.$nextTick(() => {
                this.$refs.pageTreeRef.setCurrentKey(this.currentPage + '')
            });
        },
        async setCanvasCache(data) {
            this.$store.commit('setCanvasAllData', data);
            if (!this.cacheCanvasDataKey) {
                return;
            }
            await coalescedSetProjectCache(this.$request, {
                key: this.cacheCanvasDataKey,
                value: data,
                checkLeaving: () => this.$store.state.canvasEditorLeaving,
            });
        },
        renderContent(h, { node, data, store }) {
            var _this = this;
            return (
                <span class="page-tree-node">
                    <span class="page-tree-node-label">{this.$displayLabel(node.label)}</span>
                    <span class="page-tree-node-right">
                        <el-button size="mini" type="text" class="attr-add-btn" icon="el-icon-aim" title={this.$tt("定位画布")} on-click={ (e) => {
                            e.stopPropagation();
                            eventBus.$emit('locateCanvas', { pageId: data.value });
                        }}></el-button>
                        <el-button size="mini" type="text" class="attr-add-btn" icon="el-icon-document-copy" title={this.$tt("复制页面")} on-click={ (e) => {
                            e.stopPropagation();
                            _this.$emit('copyPage', data.value);
                        }}></el-button>
                        <el-button size="mini" type="text" class="attr-add-btn" icon="el-icon-delete" title={this.$tt("删除")} on-click={ (e) => {
                            // 需要判断是否是子页面的删除
                            if (node.level === 2) {
                                // 是子页面，需要判断是否绑定，如已绑定，提示不能删除
                                var parentVal = node.parent.data.value;
                                e.stopPropagation();
                                const doClearAndDelete = () => {
                                    if (parentVal === _this.currentPage) {
                                        // 需要更改当前组件数据
                                        _this.$store.commit("changeChildPage", data.value);
                                    } else {
                                        var pages = JSON.parse(_this.canvasAllData);
                                        var datas = pages[parentVal] || [];
                                        var isChange = false;
                                        for (var i = 0;i < datas.length;i++) {
                                            var item = datas[i];
                                            if (item.component === 'ChildPage') {
                                                var bindVal = item.style.bindPage && item.style.bindPage.value;
                                                if (bindVal === data.value) {
                                                    // 绑定的是当前页面，自动清空
                                                    pages[parentVal][i].style.bindPage = null;
                                                    isChange = true;
                                                }
                                            }
                                        }
                                        if (isChange) {
                                            _this.setCanvasCache(JSON.stringify(pages));
                                        }
                                    }
                                    // 执行删除
                                    _this.$emit('deletePage', data.value, true);
                                };
                                if (_this.canvasLazyLoad && parentVal !== _this.currentPage) {
                                    eventBus.$emit("ensureCanvasPages", {
                                        pageIds: [parentVal],
                                        done: doClearAndDelete,
                                    });
                                } else {
                                    doClearAndDelete();
                                }
                            } else {
                                if (this.pageOptions.length === 1) {
                                    this.$message.error(this.$tt('页面至少要保留一个'));
                                    return;
                                }
                                e.stopPropagation();
                                this.$emit('deletePage', data.value)
                            }
                        }}></el-button>
                    </span>
                </span>);
        }
    }
};
</script>
<style lang="scss">
.page-tree {
    .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
        background-color: #bdd9f9;
    }
    .el-tree-node__content {
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        .page-tree-node {
            flex-grow: 1;
            padding-right: 8px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .page-tree-node-label {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-right: 8px;
        }
        .page-tree-node-right {
            flex-shrink: 0;
            opacity: 0.35;
            .el-button {
                padding: 4px;
            }
            .el-button + .el-button {
                margin-left: 2px;
            }
        }
        &:hover .page-tree-node-right {
            opacity: 1;
        }
    }
}
.page-components-container {
    .el-collapse-item__header {
        padding-left: 20px;
        height: 40px;
        line-height: 40px;
    }
    .el-collapse-item__content {
        padding-bottom: 0px;
    }
}
</style>
<style lang="scss" scoped>
.left-container {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    .top-tool {
        padding: 0px 10px 10px;
    }
    .page-tree {
        flex-grow: 1;
        overflow: auto;
    }
    .page-components-container {
        max-height: 50%;
    }
}
</style>
